import { Component } from 'react'
import styles from '~/styles/ordersPage.textInput.module.css'
import types from '~/types/ordersPage.ts'

export default class TextInput extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		if (!this.props.onChange && this.props.value) {
			this.state = {
				value: this.props.value,
			}
		}
	}
	
	render(): JSX.Element {
		const value = (this.props.onChange ? this.props.value : this.state.value)
		return (
			<div
				className={styles.main}
			>
				<input
					type='text'
					placeholder={this.props.placeholder || ''}
					value={value}
					className={(this.props.disabled ? styles.disabled : null)}
					onChange={this._onChange.bind(this)}
					onFocus={this._onFocus.bind(this)}
					maxLength={(this.props.maxlength + '') || "255"}
					ref={this.props.setRef || null}
				/>
			</div>
		)
	}
	
	private _onFocus(event): void {
		if (this.props.focused) {
			event.target.select()
		}
	}
	
	private _onChange(event): void {
		if (!this.props.disabled) {
			let value = event.target.value
			if (this.props.onChange) {
				if (this.props.setInputValue) {
					this.props.setInputValue(value)
				}
				this.props.onChange(value)
			} else {
				this.setState({ value })
			}
		}
	}
}